import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import { Link } from "react-router";
import Dropzone from "react-dropzone";
import Isvg from "react-inlinesvg";
import "./mediaCategory.css";
import Media from "./media.react";
import Modal from "../components/modal.react";
import Pagination from "../components/pagination/pagination.react";

export default class MediaCategory extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.loadMediaCategoryMedias();
  }

  componentDidUpdate(prevProps) {
    const { params: { uid: prevUID } } = prevProps;
    const { params: { uid } } = this.props;
    if (prevUID !== uid) {
      this.loadMediaCategoryMedias();
    }
  }

  loadMediaCategoryMedias = () => {
    const {
      actions,
      medias: { medias: { meta: mediasMeta } },
      mediaCategories: { mediaCategories: { meta: mediaCategoriesMeta } },
      params,
      notificationSystem
    } = this.props;

    actions.getMediaCategory(params.uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });

    actions.setPaginationPage("medias", 0);
    let meta = mediasMeta.toJS();
    meta.currentPage = 0;

    actions
      .getMediaCategoryMedias(params.uid, meta)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  onFileSubmit = files => {
    const self = this;
    const {
      actions,
      notificationSystem,
      params,
      medias: { medias: { meta } }
    } = this.props;

    files.forEach(function(file, index) {
      actions.uploadFile(file).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .createMediaCategoryMedia(
              {
                name: payload.name,
                description: "",
                fileUID: payload.uid
              },
              params.uid
            )
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              } else {
                actions
                  .getMediaCategoryMedias(params.uid, meta)
                  .then(({ error, payload }) => {
                    if (error) {
                      addNotificationsForInvalidFields(
                        payload,
                        notificationSystem
                      );
                    }
                  });
              }
            });
        }
      });
    });
  };

  generateMediasView = () => {
    const {
      medias: { medias: { entities: medias, results: mediasResults } },
      mediaCategories: { mediaCategories: { entities: mediaCategories } },
      params,
      config: { apiHost },
      actions
    } = this.props;
    if (mediaCategories.getIn([params.uid, "medias"])) {
      const mediasHTML = mediaCategories
        .getIn([params.uid, "medias"])
        .map(function(media, index) {
          return (
            <Media
              key={index}
              actions={actions}
              apiHost={apiHost}
              medias={medias}
              uid={media}
              mediasResults={mediasResults}
            />
          );
        });
      return mediasHTML;
    } else {
      return "";
    }
  };

  updateMedia = () => {
    const {
      actions,
      medias: { medias: { entities: medias, isEditModalVisible } },
      notificationSystem
    } = this.props;
    actions
      .updateMedia(medias.get(isEditModalVisible).toJS(), isEditModalVisible)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
    actions.setIsEditMediaModalVisible(false);
  };

  closeEditMediaModal = () => {
    const { actions } = this.props;
    actions.setIsEditMediaModalVisible(false);
  };

  openRemoveMediaModal = () => {
    const { actions, medias: { medias: { isEditModalVisible } } } = this.props;
    actions.setIsRemoveMediaModalVisible(isEditModalVisible);
    actions.setIsEditMediaModalVisible(false);
  };

  closeRemoveMediaModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveMediaModalVisible(false);
  };

  removeMedia = () => {
    const {
      actions,
      medias: { medias: { isRemoveModalVisible, meta } },
      notificationSystem,
      params
    } = this.props;
    actions.removeMedia(isRemoveModalVisible).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions
          .getMediaCategoryMedias(params.uid, meta)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
      }
    });
    actions.setIsRemoveMediaModalVisible(false);
  };

  paginationAction = page => {
    const {
      actions,
      notificationSystem,
      medias: { medias: { meta: mediasMeta } },
      params
    } = this.props;
    actions.setPaginationPage("medias", page);
    let meta = mediasMeta.toJS();
    meta.currentPage = page;
    actions
      .getMediaCategoryMedias(params.uid, meta)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  render() {
    const {
      actions,
      medias: {
        medias: {
          isRemoveModalVisible,
          isEditModalVisible,
          entities: medias,
          meta: mediasMeta
        }
      },
      mediaCategories: { mediaCategories: { entities: mediaCategories } },
      params,
      config: { apiHost }
    } = this.props;

    const mediasHTML = this.generateMediasView();

    const editMediaProps = {
      actions: actions,
      feature: "medias",
      uid: isEditModalVisible,
      entity: medias.get(isEditModalVisible)
    };

    return (
      <div className="islogged-page">
        <div className="row">
          <div className="col-xs-12">
            <h2>{mediaCategories.getIn([params.uid, "name"])}</h2>
          </div>
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">
                Lista plików
                <span className="subtitle">
                  {mediaCategories.getIn([params.uid, "description"])}
                </span>
              </div>
              <div className="content-wrapper">
                <Dropzone
                  onDrop={this.onFileSubmit}
                  className="dropzone"
                  activeClassName="dropzone-active"
                >
                  <div>
                    <Isvg
                      className="dropzone-icon"
                      src="/assets/img/icon_upload.svg"
                    />
                    <p className="dropzone-text">
                      Upuść lub kliknij aby dodać plik
                    </p>
                  </div>
                </Dropzone>
                <div className="row">{mediasHTML}</div>
                <Pagination
                  numberOfPages={Math.ceil(mediasMeta.all / mediasMeta.limit)}
                  setPageAction={this.paginationAction}
                  maxPagesDisplay={5}
                  currentPage={mediasMeta.currentPage + 1}
                />
              </div>
            </div>
          </div>
        </div>

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditMediaModal}
            enterAction={this.updateMedia}
            deleteAction={this.openRemoveMediaModal}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Edytuj media</h3>
              <div className="col-xs-12 center-xs">
                <img
                  src={`${apiHost}/v1/files/${medias.getIn([
                    isEditModalVisible,
                    "fileUID"
                  ])}/file`}
                />
              </div>
              <div className="col-xs-12">
                <InputCustom
                  placeholder="Opis pliku"
                  field={["description"]}
                  {...editMediaProps}
                />
              </div>
              <div className="col-xs-12">
                <button className="info" onClick={this.updateMedia}>
                  Aktualizuj opis
                </button>
                <button className="error" onClick={this.openRemoveMediaModal}>
                  Usuń
                </button>
              </div>
            </div>
          </Modal>
        )}

        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveMediaModal}
            enterAction={this.removeMedia}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <div className="col-xs-12 center-xs">
                <img
                  src={`${apiHost}/v1/files/${medias.getIn([
                    isRemoveModalVisible,
                    "fileUID"
                  ])}/file`}
                />
              </div>
              <div className="col-xs-12">
                <p>Czy napewno usunąć?</p>
                <button className="error" onClick={this.removeMedia}>
                  Usuń
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/mediaCategory/mediaCategory.react.js